import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from '@components/Input';
import { APP_TYPES } from '@config';
import { APP_TEXTS } from '@texts';
import './styles.scss';
import { setScrewOptions } from '@reducers/options/screw/actions';

class HolesConfigurationB extends Component {

  handleDiameterChange = (value) => {
    this.props.setScrewOptions({
      radius: Number(value) / 2
    });
  };

  handleNChange = (value) => {
    const newN = Number(value);
    const spacing = 15;
    const totalWidth = (newN - 1) * spacing;
    const startX = -totalWidth / 2;

    const newCoordinates = Array(newN).fill(0).map((_, index) => ({
      id: index + 1,
      x: startX + (index * spacing),
      y: 0,
    }));

    this.props.setScrewOptions({
      count: {
        n: newN
      },
      custom: {
        positions: newCoordinates
      }
    });
  };

  handleCoordinateChange = (id, field, value) => {
    const newCoordinates = this.props.anchorsConfiguration.coordinates.map(coord =>
      coord.id === id ? { ...coord, [field]: Number(value) } : coord
    );
    this.props.setScrewOptions({
      custom: {
        positions: newCoordinates
      }
    });
  };

  handleCheckboxChange = (e) => {
    this.props.setScrewOptions({
      custom: {
        active: e.target.checked
      }
    });
  };

  render() {
    return (
      <div className="list-type">
        <Input
          id="diameter"
          type="number"
          value={this.props.anchorsConfiguration.diameter}
          onUpdate={this.handleDiameterChange}
          className="d-flex align-items-center mb-3"
          prefix={
            <span className="prefix-label">
              {APP_TEXTS.WOOD_CONNECTION_HOLE_DIAMETER.Content}
            </span>
          }
          postfix="mm"
        />
        <Input
          id="n-count"
          type="number"
          value={this.props.anchorsConfiguration.n}
          onUpdate={this.handleNChange}
          className="d-flex align-items-center mb-3"
          prefix={<span className="prefix-label">{APP_TEXTS.NEWTON.Content}</span>}
        />
        <div className="mt-3">
          <div className="mb-2">
            <input
              type="checkbox"
              id="coordinates-toggle"
              checked={this.props.anchorsConfiguration.isCoordinatesEnabled}
              onChange={this.handleCheckboxChange}
              className="mr-2"
            />
            <label htmlFor="coordinates-toggle">
              {APP_TEXTS.WOOD_CONNECTION_ENABLE_COORDINATES.Content}
            </label>
          </div>
          {this.props.anchorsConfiguration.isCoordinatesEnabled && (
            <table className="table">
              <thead>
                <tr>
                  <th>{APP_TEXTS.WOOD_CONNECTION_COORDINATES_TABLE_INDEX.Content}</th>
                  <th>{APP_TEXTS.WOOD_CONNECTION_COORDINATES_TABLE_X.Content}</th>
                  <th>{APP_TEXTS.WOOD_CONNECTION_COORDINATES_TABLE_Y.Content}</th>
                </tr>
              </thead>
              <tbody>
                {this.props.anchorsConfiguration.coordinates.map(coord => (
                  <tr key={coord.id}>
                    <td>{coord.id}</td>
                    <td>
                      <Input
                        id={`coord-x-${coord.id}`}
                        type="number"
                        value={coord.x}
                        onUpdate={(value) => this.handleCoordinateChange(coord.id, 'x', value)}
                      />
                    </td>
                    <td>
                      <Input
                        id={`coord-y-${coord.id}`}
                        type="number"
                        value={coord.y}
                        onUpdate={(value) => this.handleCoordinateChange(coord.id, 'y', value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  anchorsConfiguration: state.dimension[APP_TYPES.WOOD_CONNECTION].anchorsConfiguration
});
export default connect(mapStateToProps, { setScrewOptions })(HolesConfigurationB);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/HolesConfigurationB/HolesConfigurationB.js